import { SimplePdfEditor } from "@/components/debug/SimplePdfEditor";
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';


export const Route = createFileRoute('/pdftest')({
  component: DebugPage,
})

function DebugPage() {
  useEffect(() => {
    document.title = `Identity Verification Debug | Swim Homes`;
  }, []);

  return (
    <div className="h-screen bg-gray-50">
      <SimplePdfEditor />
    </div>
  );
}
